<template>
    <div class="story-form-post-creator hide-scrollbar" ref="scrollableDiv">
         <!-- //////////////  Standard mode  //////////////-->
        <section class="publish-date" v-if="tab !== 'story_share'">
            <label>{{ $t('dash.post-creator.form.publish-date') }} <span v-if="updateFormData.planifiedDate" @click="$emit('restoreFormData','planifiedDate')" class="restore">{{ $t('dash.post-creator.form.cancel-changes') }}</span></label>
            <div class="content-section">
                <SelectComponent 
                    :changeValueSelect="changeSelectPublishDate" 
                    :data="{now: $t('dash.post-creator.form.now'), flanified: $t('dash.button.schedule')}"
                    :valueSelect="!formData.planifiedDate.date ? 'now' : 'flanified'" 
                    :positionAuto="false" :positionX="'left'">
                </SelectComponent>
                <template v-if="formData.planifiedDate.date !== false && formData.planifiedDate.hours !== false">
                    <div class="input-date">        
                        <p>{{ formatInputDatePicker }}</p>
                        <i class="fa-regular fa-calendar"></i>
                        <input type="date" 
                            v-model="formData.planifiedDate.date" 
                            :disabled="formData.planifiedDate.date ? false : true" 
                            @click="(e)=>e.target.showPicker()" 
                            :min="new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')"
                        >
                    </div>
                    <div class="input-hours">
                        <VueTimepicker v-model="formData.planifiedDate.hours" manual-input @close="checkValidHours()"/>
                        <i class="fa-regular fa-clock"></i>
                    </div>
                </template>
            </div>
        </section>

        <!-- ////////////  Storification mode ////////////-->
        <section class="publish-date" v-else>
            <label>{{ $t('dash.post-creator.form.publish-date') }}
                <span
                    v-if="
                        updateFormData.formDataNetwork &&
                        updateFormData.formDataNetwork.instagram &&
                        updateFormData.formDataNetwork.instagram.storification &&
                        updateFormData.formDataNetwork.instagram.storification.planifiedDate
                    "
                    @click="$emit('restoreFormData','planifiedDate')"
                    class="restore"
                >
                    {{ $t('dash.post-creator.form.cancel-changes') }}
                </span>
            </label>
            <div class="content-section">
                <SelectComponent 
                    :changeValueSelect="changeSelectPublishDateStorification" 
                    :data="{now: $t('dash.post-creator.form.simultaneous'), flanified: $t('dash.button.schedule')}"
                    :valueSelect="
                        !formData.formDataNetwork.instagram.storification ||
                        !formData.formDataNetwork.instagram.storification.planifiedDate ||
                        !formData.formDataNetwork.instagram.storification.planifiedDate.date 
                        ? 'now' 
                        : 'flanified'" 
                    :positionAuto="false" :positionX="'left'">
                </SelectComponent>

                <div class="input-date" v-if="formData.formDataNetwork.instagram.storification.planifiedDate.date">        
                    <p>{{ formatInputDatePickerStorification }}</p>
                    <i class="fa-regular fa-calendar"></i>
                    <input type="date" 
                        v-model="formData.formDataNetwork.instagram.storification.planifiedDate.date" 
                        :disabled="formData.formDataNetwork.instagram.storification.planifiedDate.date ? false : true" 
                        @click="(e)=>e.target.showPicker()" 
                        :min="new Date(formData.planifiedDate.date ? formData.planifiedDate.timestamp : null).toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')"
                    >
                </div>
                <div class="input-hours" v-if="formData.formDataNetwork.instagram.storification.planifiedDate.hours !== false">
                     <VueTimepicker v-model="formData.formDataNetwork.instagram.storification.planifiedDate.hours" manual-input 
                     @close="checkValidHoursStorification()"/>
                    <i class="fa-regular fa-clock"></i>
                </div>
            </div>
        </section>

        <!-- /////////////////////////////////////////////-->


        <section class="content-media">
            <label>{{ $t('dash.post-creator.story.background') }} <span v-if="updateFormData.storification && updateFormData.storification[this.idStorySelected] && updateFormData.storification[this.idStorySelected].background" @click="()=>$emit('restoreFormData',['storification',this.idStorySelected,'background'])" class="restore">{{ $t('dash.post-creator.form.cancel-changes') }}</span></label>
            <div class="container-medias">
                <div class="btn-color" @click="()=>{colorPickerShow = true; showPipette = true}" :style="{backgroundColor:formData.storification[this.idStorySelected].background.color}">
                    <div class="picker-color" v-if="colorPickerShow" @mouseleave="()=>{colorPickerShow = false; this.$emit('saveFormData')}" @mousedown="showPipette = false">
                        <div class="icon-pipette" v-if="eyeDropperIsAccess && showPipette" @mousedown.stop @click.stop="startEyeDropper"></div>
                        <chrome-picker :value="{hex:formData.storification[this.idStorySelected].background.color}" @input="updateFromPicker"/>
                    </div>
         
                </div>

                <template v-if="tab != 'story_share' && !hasPostSticker">

                    <input
                        v-validate="''"
                        name="file"
                        type="file"
                        id="file"
                        ref="inputMediaStory"
                        @change="uploadBackgroundFile"
                        :multiple="false"
                        @click="()=>{}"
                        :accept="'.jpg, .jpeg, .png, .webp, .mp4, .gif, .webm, .ogg, .avi, .wmv, .flv, .mkv, .mov'" 
                        hidden
                    >         
                    <DropFile :targetInput="$refs.inputMediaStory"/>
                    <!-- .avi, .mov, .mkv -->

                    

                    <template v-if="backgroundFileId && files[backgroundFileId]">
                        <Tooltip
                            :active="!files[backgroundFileId].isUpload && !files[backgroundFileId].uploadProgress"
                            :text="$t('dash.post-creator.media.upload-failed')"
                            position="bottom"
                        >
                            <div class="media-container picture" v-if="files[backgroundFileId].info.type.startsWith('image/')" @click="openBackgroundResizeMode">
                                <i v-if="!files[backgroundFileId].isUpload && !files[backgroundFileId].uploadProgress" class="fa-solid fa-rotate-right" @click.stop="retryBackgroundFile"></i>
                                <i class="fa-solid fa-circle-xmark" @click.stop="removeBackgroundFile"></i>
                                <div class="media picture">
                                    <img draggable="false" :src="files[backgroundFileId].url" alt="" class="source">
                                </div>
                                <Tooltip
                                    :active="isBackgroundMediaLoading"
                                    :text="$t('dash.post-creator.thumbnail.loading')"
                                    position="bottom"
                                    :classCustom="'video-edit-btn' + (isBackgroundMediaLoading ? ' disabled' : '')"
                                    @click.stop="!isBackgroundMediaLoading && !mediaEditorData.exporting && $emit('startEditImageBackground', backgroundFileId)"
                                >
                                    <i class="fa-solid fa-pen"></i>
                                </Tooltip>
                                <div v-if="mediaEditorData.exporting && mediaEditorData.fileId === backgroundFileId" class="containerProgressBar">
                                    <div class="progressBar">
                                        <div class="bar" :style="{width: `${Math.round(mediaEditorData.exportProgress * 100)}%`}"></div>
                                    </div>
                                </div>
                                <div v-else-if="!files[backgroundFileId].isUpload && files[backgroundFileId].uploadProgress" class="containerProgressBar">
                                    <div class="progressBar">
                                        <div class="bar" :style="{width: `${parseInt(files[backgroundFileId].percentUpload)}%`}"></div>
                                    </div>
                                </div>
                                <Tooltip
                                    v-if="formData.storification[idStorySelected].background.file.mediaEditorData && formData.storification[idStorySelected].background.file.mediaEditorData.exportError"
                                    :active="true"
                                    :text="formData.storification[idStorySelected].background.file.mediaEditorData.exportError"
                                    position="bottom"
                                    classCustom="icon-normalized warning-icon-normalized"
                                >
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                </Tooltip>
                            </div>


                        <div class="media-container video" v-else-if="files[backgroundFileId].info.type.startsWith('video/')">

                            <i class="fa-solid fa-circle-xmark" @click.stop="removeBackgroundFile"></i>
                            <div class="media video">

                                <video muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true" :src="files[backgroundFileId].url" :type="files[backgroundFileId].info.type">
                                </video>
                            </div>
                            <Tooltip
                                :active="isBackgroundMediaLoading"
                                :text="$t('dash.post-creator.thumbnail.loading')"
                                position="bottom"
                                :classCustom="'video-edit-btn' + (isBackgroundMediaLoading ? ' disabled' : '')"
                                @click.stop="!isBackgroundMediaLoading && !mediaEditorData.exporting && $emit('startEditVideoBackground', backgroundFileId)"
                            >
                                <i class="fa-solid fa-pen"></i>
                            </Tooltip>
                            <div v-if="mediaEditorData.exporting && mediaEditorData.fileId === backgroundFileId" class="containerProgressBar">
                                <div class="progressBar">
                                    <div class="bar" :style="{width: `${Math.round(mediaEditorData.exportProgress * 100)}%`}"></div>
                                </div>
                            </div>
                            <Tooltip
                                v-if="formData.storification[idStorySelected].background.file.mediaEditorData && formData.storification[idStorySelected].background.file.mediaEditorData.exportError"
                                :active="true"
                                :text="formData.storification[idStorySelected].background.file.mediaEditorData.exportError"
                                position="bottom"
                                classCustom="icon-normalized warning-icon-normalized"
                            >
                                <i class="fa-solid fa-triangle-exclamation"></i>
                            </Tooltip>
                        </div>
                        </Tooltip>
                    </template>
                    

                    <div class="btn-add-media" v-else @click="clickBtnAddMedia">
                        <i class="fa-solid fa-photo-film"></i>
                    </div>
                </template>


            </div>
        </section>

        <section class="content-stickers">
            <label>{{ $t('dash.post-creator.story.stickers') }} <span v-if="updateFormData.storification && updateFormData.storification[this.idStorySelected] && updateFormData.storification[this.idStorySelected].stickers" @click="()=>$emit('restoreFormData',['storification',this.idStorySelected,'stickers'])" class="restore">{{ $t('dash.post-creator.form.cancel-changes') }}</span></label>
            <div class="container-stickers">
                <draggable class="list-stickers hide-scrollbar" ref="listStickers" v-model="stickersSortByZIndex" v-bind="dragOptions" @start="drag=true" @end="onDragStickerEnd" :filter="'.lockdrag'">
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        
                        <template v-for="sticker in stickersSortByZIndex" >
                            <div v-if="sticker.id == 'btnAdd'" @click="openMenuStickers" class="btn-add-sticker lockdrag" :class="{'no-drag' : drag}" :key="'btnAdd'">
                                <svg width="auto" height="auto" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6667 0H31.3333C38.3289 0 44 5.67106 44 12.6667V25.1242C44 26.5387 43.4381 27.8952 42.4379 28.8954L28.8954 42.4379C27.8952 43.4381 26.5387 44 25.1242 44H12.6667C5.67106 44 0 38.3289 0 31.3333V12.6667C0 5.67106 5.67106 0 12.6667 0ZM12.6667 4C7.8802 4 4 7.8802 4 12.6667V31.3333C4 36.1198 7.8802 40 12.6667 40H25.3333L40 25.3333V12.6667C40 7.8802 36.1198 4 31.3333 4H12.6667Z" fill="#F1EDF5"/>
                                    <path d="M35.334 23.334H43.334L41.334 27.334H35.334C30.9157 27.334 27.334 30.9157 27.334 35.334V40.6673L23.334 41.334V35.334C23.334 28.7066 28.7066 23.334 35.334 23.334Z" fill="#F1EDF5"/>
                                    <path d="M16.6673 18.0007C16.6673 19.4734 15.4734 20.6673 14.0007 20.6673C12.5279 20.6673 11.334 19.4734 11.334 18.0007C11.334 16.5279 12.5279 15.334 14.0007 15.334C15.4734 15.334 16.6673 16.5279 16.6673 18.0007Z" fill="#F1EDF5"/>
                                    <path d="M32.6673 18.0007C32.6673 19.4734 31.4734 20.6673 30.0007 20.6673C28.5279 20.6673 27.334 19.4734 27.334 18.0007C27.334 16.5279 28.5279 15.334 30.0007 15.334C31.4734 15.334 32.6673 16.5279 32.6673 18.0007Z" fill="#F1EDF5"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9633 26.2096C13.7676 25.4526 15.0334 25.4909 15.7904 26.2953C17.9806 28.6224 20.4661 29.1591 22.4662 29.1247C23.4806 29.1072 24.3615 28.9402 24.986 28.7775C25.2962 28.6967 25.5372 28.6185 25.6927 28.5638C25.7703 28.5365 25.8261 28.5152 25.8581 28.5027C25.874 28.4965 25.884 28.4924 25.8876 28.4909L25.8852 28.492L25.8826 28.4931M25.8881 28.4907C26.9014 28.062 28.0717 28.5325 28.5056 29.5448C28.9407 30.5601 28.4704 31.7359 27.4552 32.171L26.675 30.3507C27.4552 32.171 27.4543 32.1714 27.4534 32.1718L27.4514 32.1726L27.4469 32.1745L27.4361 32.1791L27.4065 32.1913C27.3834 32.2008 27.3534 32.2129 27.3168 32.2273C27.2435 32.2559 27.1437 32.2936 27.0195 32.3373C26.7715 32.4245 26.4239 32.5364 25.9945 32.6483C25.1398 32.871 23.9374 33.0999 22.5351 33.1241C19.7019 33.1729 16.0207 32.3763 12.8776 29.0368C12.1206 28.2324 12.1589 26.9667 12.9633 26.2096M25.8881 28.4907C25.888 28.4908 25.8878 28.4909 25.8876 28.4909L25.8884 28.4906L25.8892 28.4903C25.889 28.4904 25.8887 28.4905 25.8881 28.4907Z" fill="#F1EDF5"/>
                                </svg>
                            </div>
                            <div v-else class="stricker" @click="()=>clickSticker(sticker.id)" :class="{'lockdrag' : ['music','music_missing','post'].includes(sticker.type), 'no-drag' : drag && sticker.type == 'post', 'sticker-music-missing-item': sticker.type === 'music_missing'}" :key="sticker.id">
                                <i v-if="sticker.type !== 'post'" class="fa-solid fa-circle-xmark" @click.stop="deleteSticker(sticker.id)"></i>
                                <div class="sticker-view">

                                    <Tooltip
                                        v-if="sticker.type == 'music'"
                                        :text="
                                            sticker.data.music && 
                                            `
                                            ${sticker.data.music.track ? sticker.data.music.track.display_artist : (sticker.data.music.original_sound && sticker.data.music.original_sound.ig_artist ? sticker.data.music.original_sound.ig_artist.full_name : '')} -
                                            ${(sticker.data.music.track ? sticker.data.music.track.title : sticker.data.music.original_sound.title)}
                                            `
                                        "
                                        position="bottom"
                                        classCustom="music"
                                    >
                                        <div class="disk">
                                            <img :src="sticker.data.music.track ? sticker.data.music.track.cover_artwork_thumbnail_uri : (sticker.data.music.original_sound && sticker.data.music.original_sound.ig_artist ? sticker.data.music.original_sound.ig_artist.profile_pic_url : '')">
                                        </div>

                                    </Tooltip>

                                    <div v-else-if="sticker.type === 'music_missing'" class="music-missing-label">
                                        <i class="fa-solid fa-triangle-exclamation"></i>
                                        <span>{{ $t('dash.post-creator.story.sticker.music-missing') }}</span>
                                        <span class="action">{{ $t('dash.post-creator.story.sticker.music-missing-action') }}</span>
                                    </div>

                                    <stickerWrapper v-else
                                        :sticker="{...sticker, isEditing: false}"
                                        :files="files"
                                    />
                                </div>
                                <p class="sticker-type">{{ sticker.type === 'music_missing' ? '' : sticker.type }}</p>
                            </div>
                        </template >
                       
                    </transition-group>
                </draggable>
            </div>
        </section>

        <section class="content-facebook" v-if="tab !== 'story_share'">
            <label>Facebook</label>
            <div class="type-switch">
                {{ $t('dash.post-creator.story.share-on-facebook') }}

                <ComponentSwitch :value="this.formData.storification[this.idStorySelected].shareInStoryFacebook" :onChange="handlerSharePostInStoryFacebook" :id="'switch-share-story'"/>
 
            </div>
        </section>
    </div>
</template>

<script>

import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import SelectComponent from '@/components/dash/utils/select.vue'
import ComponentSwitch from '@/components/dash/utils/switch.vue'
import Checkbox from '@/components/dash/utils/checkbox.vue'
import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'

import draggable from 'vuedraggable'
import minxinBot from '@/components/mixins/Bots.vue'
import minxinPosts from '@/components/mixins/Posts.vue'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import stickerWrapper from './storyMaker/stiker/stickerWrapper.vue';
import { Chrome } from 'vue-color'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import DropFile from '@/components/dash/DropFile.vue'
import { getValidPlanifiedDateTime } from '../../utils.js'

// import * as pdfjsLib from 'pdfjs-dist/webpack';

// // Configure the workerSrc to use the correct version of the worker script
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js`;


export default {
    mixins: [minxinBot, minxinPosts],
    components: {
        SelectComponent,
        ComponentSwitch,
        Checkbox,
        Tooltip,
        ContextMenu,
        draggable,
        stickerWrapper,
        'chrome-picker': Chrome,
        VueTimepicker,
        DropFile,
    },

    props: {
        typeRenderNetworkSelected: {
            type: String,
            default: 'facebook'
        },

        idPageRenderNetworkSelected: String,

        formData :  Object,
        
        updateFormData : {
            type: Object,
            default: () => ({})
        },
        
        personalizationMode : {
            type: Boolean,
            default: false
        },

        uploadFilesServer : {
            type: Object,
            default: () => ({})
        },

        idStorySelected: {
            type: String,
            default: '0'
        },

        files:Object,
        tab: String,

        // Lifted to StoryTab.vue (which never gets destroyed/recreated, unlike this component -
        // see StoryTab.vue's formShow/previewMode watcher) so an export in progress survives
        // switching to the preview screen, where "Valider" (sendPostAllPost) is clicked.
        mediaEditorData: {
            type: Object,
            default: () => ({ exporting: false, exportProgress: 0, fileId: null })
        },
    },

    data() {
        return {
            lastModeSelected : undefined,
            drag : false,
            timeoutVerifMetaUrl: null,

            stickersSortByZIndex : [],

            eyeDropperIsAccess : false,
            colorPickerShow: false,
            showPipette: false,
        }
    },

    created () {
        console.log('created form formdata ', this.formData)
    },

    mounted () {
       this.sortStickers()
       this.eyeDropperIsAccess = window.EyeDropper ? true : false
    },

    methods: {
        addMode(mode, data = {}) {
            this.lastModeSelected = mode
            EventBus.$emit("postCreatorAddMode", mode, data);
        },
            
        changeSelectPublishDate(value) {
            if (!this.date && value == "flanified") {
                let date = new Date((new Date).getTime() + 3600000)
                this.$set(this.formData.planifiedDate, 'date', date.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-'));
                this.$set(this.formData.planifiedDate, 'hours', date.toLocaleString('fr-FR').split(' ')[1].split(':').slice(0,2).join(':'));
            }else if(value == "now") {
                this.$set(this.formData.planifiedDate, 'date',false)
                this.$set(this.formData.planifiedDate, 'hours', false)
            }  
        
            this.$emit('saveFormData')
        },

        changeSelectPublishDateStorification(value) {
            if (!this.date && value == "flanified") {
                let date = this.formData.planifiedDate.date ? new Date(this.formData.planifiedDate.timestamp+ 3600000) : new Date((new Date).getTime() + 3600000)
                this.$set(this.formData.formDataNetwork.instagram.storification.planifiedDate, 'date', date.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-'));
                this.$set(this.formData.formDataNetwork.instagram.storification.planifiedDate, 'hours', date.toLocaleString('fr-FR').split(' ')[1].split(':').slice(0,2).join(':'));
            }else if(value == "now") {
                this.$set(this.formData.formDataNetwork.instagram.storification.planifiedDate, 'date',false)
                this.$set(this.formData.formDataNetwork.instagram.storification.planifiedDate, 'hours', false)
            }  
        
            this.$emit('saveFormData')
        },

        clickBtnAddMedia(id=null, value=null) {

            switch (value) {
                case 'link':
                    EventBus.$emit("storyMaker-setOverlay", false)
                    break;
            
                case 'file':
                    this.$refs.inputMediaStory.click()
                    break;
                default:
                    this.$refs.inputMediaStory.click()
                    break;
            }

        },

        async uploadBackgroundFile(event) {
            const file = event.target.files[0];
            const id = Math.random().toString(36).substr(2, 9)
            if (file) {

                this.$emit('addFile',null, file, true, id, ()=> {
                    if (this.files[id]) {
                        this.$set(
                            this.formData.storification[this.idStorySelected].background, 
                            'file', 
                            {
                                id: id,
                            }
                        )
                        if (this.files[id].info.aspectRatio) {
                        
                            this.$set(
                                this.formData.storification[this.idStorySelected].background, 
                                'size', 
                                this.files[id].info.aspectRatio > 0.5625 ? 'containX' : 'containY'
                            )
                        }
                        if (this.files[id].info.averageColor) {
                            this.$set(
                                this.formData.storification[this.idStorySelected].background, 
                                'color', 
                                this.files[id].info.averageColor
                            )
                        }
                        this.$emit('saveFormData')
                        this.openBackgroundResizeMode()
                    }
                })
            }
        },
 
        removeBackgroundFile(id) {
            const removedFileId = this.backgroundFileId
            this.$set(
                this.formData.storification[this.idStorySelected],
                'background',
                {
                    file : false,
                    color : this.formData.storification[this.idStorySelected].background.color,
                    size : 'containX',
                    position: {"x":50,"y":50},
                    transform: {"rotate":0,"scale":1}
                }
            )
            this.$emit('saveFormData')
            // purge le registre partagé si le fichier n'a jamais fini d'uploader (no-op sinon, cf PostCreator.vue)
            this.$emit('discardFailedFile', removedFileId)
        },

        retryBackgroundFile() {
            this.$emit('retryUploadFile', this.backgroundFileId)
        },

        clickBtnAddVideoPreview(id) {
            this.$refs.inputVideoPreview.setAttribute('idMedia', id)
            this.$refs.inputVideoPreview.click()
        },
        
        calculTimeStampPlanifiedDate() {
            let date = new Date(this.formData.planifiedDate.date)

            if (String(this.formData.planifiedDate.hours).includes(":")) {
                let [hours, minutes] = String(this.formData.planifiedDate.hours).split(':').map(value => isNaN(value) ? 0 : parseInt(value))
                date.setMinutes(minutes)
                date.setHours(hours)
            }

            this.$set(this.formData.planifiedDate, 'timestamp', date.getTime());
            this.$emit('saveFormData')
        },

        calculTimeStampPlanifiedDateStorification() {
            const planifiedDateRef = this.formData.formDataNetwork.instagram.storification.planifiedDate
            let date = new Date(planifiedDateRef.date)

            if (planifiedDateRef.hours.includes(":")) {
                let [hours, minutes] = planifiedDateRef.hours.split(':').map(value => isNaN(value) ? 0 : parseInt(value))
                date.setMinutes(minutes)
                date.setHours(hours)
            }

            this.$set(this.formData.formDataNetwork.instagram.storification.planifiedDate, 'timestamp', date.getTime());
            this.$emit('saveFormData')
        },

        checkValidHours() {
            if (!this.formData.planifiedDate.date) return

            const { date, hours } = getValidPlanifiedDateTime(this.formData.planifiedDate.date, this.formData.planifiedDate.hours)

            this.$set(this.formData.planifiedDate, 'hours', hours)
            this.$set(this.formData.planifiedDate, 'date', date)
            this.calculTimeStampPlanifiedDate()
        },

        checkValidHoursStorification() {
           
            const planifiedDateRef = this.formData.formDataNetwork.instagram.storification.planifiedDate
            console.log('checkValidHoursStorification',planifiedDateRef)
            if (!planifiedDateRef.hours) {
                planifiedDateRef.hours = '09:00' //valeur par default
            }

            let [hours, minutes] = planifiedDateRef.hours.split(':').map(value => isNaN(value) ? 0 : parseInt(value))
            hours = Math.max(0, Math.min(24, hours))
            minutes = Math.max(0, Math.min(59, minutes))
           

            let minDate = new Date(new Date(this.formData.planifiedDate.date ? this.formData.planifiedDate.timestamp : null).getTime() + 600000) //date actuelle + 10 minutes
            
            let planifiedDate = new Date(planifiedDateRef.date)
            planifiedDate.setHours(hours)
            planifiedDate.setMinutes(minutes)
            let date = null
            if (planifiedDate < minDate) {

                hours = minDate.getHours()
                minutes = minDate.getMinutes()
                date = minDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')
            }

            console.log('checkValidHoursStorification',date)
            if (date) {
                this.$set(this.formData.formDataNetwork.instagram.storification.planifiedDate, 'date', date);
            }
            this.$set(this.formData.formDataNetwork.instagram.storification.planifiedDate, 'hours', `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`)
            this.calculTimeStampPlanifiedDateStorification()
        },

        setFormDataNetwork(typeNetwork, data) {
            console.log('setFormDataNetwork',typeNetwork, this.personalizationMode)
            if (this.personalizationMode && typeNetwork !== this.typeRenderNetworkSelected) return
            this.$set(this.formData.formDataNetwork, typeNetwork, data);
            this.$emit('saveFormData')
        },

        handlerSharePostInStoryFacebook(state) {
            this.$set(this.formData.storification[this.idStorySelected], 'shareInStoryFacebook', state);
            this.$emit('saveFormData')
        },

        async fileToArrayBuffer(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();

                reader.onload = function(e) {
                    let arrayBuffer = new Uint8Array(reader.result);
                    resolve(arrayBuffer)
                }

                reader.readAsArrayBuffer(file);
            });
        },

        sortStickers() {
            const musicFirst = (s) => (s.type === 'music' || s.type === 'music_missing') ? 1 : 0;
            this.stickersSortByZIndex = [{id:'btnAdd'}, ...Object.values(this.formData.storification[this.idStorySelected].stickers).sort((a,b)=> parseFloat(musicFirst(b) ? 1 : b.zIndex) - parseFloat(a.zIndex))]
        },

        onDragStickerEnd(event) {
            console.log("onDragStickerEnd",event, event.newIndex,this.stickersSortByZIndex[event.newIndex - 1])
            var sticker = this.stickersSortByZIndex[event.newIndex];
            

            if (sticker.type == "gif" && this.stickersSortByZIndex[event.newIndex - 1] && this.stickersSortByZIndex[event.newIndex - 1].type !== "gif") {
                //suprime le sticker devant le sticker gif
                this.stickersSortByZIndex.splice(event.newIndex, 1);
                //trouve le premier index n'etant pas un gif
                let maxIndex = this.stickersSortByZIndex.findIndex(s => s.type !== "gif" && s.id !== 'btnAdd' && s.id !== sticker.id)

                if (maxIndex >= 0) {
                    this.stickersSortByZIndex.splice(maxIndex, 0, sticker);  
                }else{
                    this.stickersSortByZIndex.splice(event.oldIndex, 0, sticker);  
                }

            }

            //bloque le fait de mettre un sticker en dessous d'un post
            else if (this.stickersSortByZIndex[event.newIndex - 1] && this.stickersSortByZIndex[event.newIndex - 1].type == "post") {
               
                //suprime le sticker derriere le sticker post
                this.stickersSortByZIndex.splice(event.newIndex, 1);
                //le duplique devant le sticker post
                this.stickersSortByZIndex.splice(event.newIndex - 1, 0, sticker);  
                
           
            } 
            //bloque le fait de mettre un sticker au desus d'un gif
            else if (sticker.type !== "gif" && this.stickersSortByZIndex[event.newIndex + 1] && this.stickersSortByZIndex[event.newIndex + 1].type == "gif") {
                //suprime le sticker devant le sticker gif
                this.stickersSortByZIndex.splice(event.newIndex, 1);
                //trouve le premier index n'etant pas un gif
                let maxIndex = this.stickersSortByZIndex.findIndex(s => s.type !== "gif" && s.id !== 'btnAdd' && s.id !== sticker.id)

                if (maxIndex >= 0) {
                    this.stickersSortByZIndex.splice(maxIndex, 0, sticker);  
                }else{
                    this.stickersSortByZIndex.splice(event.oldIndex, 0, sticker);  
                }
            }
        
            
            this.drag=false


            this.$set(
                this.formData.storification[this.idStorySelected], 
                'stickers', 
                this.stickersSortByZIndex
                    .filter(sticker => sticker.id !== 'btnAdd')
                    .reduce((acc, sticker, index) => ({
                        ...acc,
                        [sticker.id]: {
                            ...sticker,
                            zIndex: this.stickersSortByZIndex.length - index,
                        }
                    }), {})
            ) 
            EventBus.$emit("storyMaker-setOverlay", false)
            this.$emit('saveFormData')
        
        },

        deleteSticker(id) {
            this.$delete(this.formData.storification[this.idStorySelected].stickers, id)  
            this.$emit('saveFormData')       
        },

        clickSticker(id) {
            const sticker = this.formData.storification[this.idStorySelected].stickers[id]
            if (!sticker) return
            if (sticker.type === 'music_missing') {
                EventBus.$emit('storyMaker-setOverlay', 'stickers-musicMenu', sticker.data.trackName)
                return
            }
            const typeStikerEdited = ['survey','text','slider', 'music','mention', 'hashtag', 'product', 'link']
            if (typeStikerEdited.includes(sticker.type)) {
                this.$set(this.formData.storification[this.idStorySelected].stickers,id, {
                    ...sticker,
                    isEditing: true,
                })
                this.$emit('saveFormData')
            }
        },

        openBackgroundResizeMode() {
            if (this.files[this.backgroundFileId].info.type.startsWith('image/')) {
                EventBus.$emit("storyMaker-setOverlay", 'backgroundResize')
            }

        },

        openMenuStickers() {
            EventBus.$emit("storyMaker-setOverlay", 'stickers')
        },

        updateFromPicker(value) {
            this.$set(this.formData.storification[this.idStorySelected].background, 'color', value.hex)
        },

        startEyeDropper() {
            if (!window.EyeDropper) return
            this.colorPickerShow = false
            this.$emit('saveFormData')
            const eyeDropper = new EyeDropper();

            eyeDropper.open().then((result) => {
                this.$set(this.formData.storification[this.idStorySelected].background, 'color', result.sRGBHex)
                this.$emit('saveFormData')
            }).catch((e) => {
            });
        },

    },

    computed: {
        console: () => console,

        formatInputDatePicker() {
            if(this.formData.planifiedDate.date == false) return '';
            let dateNow = new Date()
            let dateFuture = new Date(this.formData.planifiedDate.date)
      
            if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                if (Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24)) < 7) {
                    if (dateFuture.getDay() === dateNow.getDay()) return this.$t('dash.post-creator.render.today')
                    if (dateFuture.getDay() === dateNow.getDay()+1) return this.$t('dash.post-creator.render.tomorrow')
                    return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long' });
                }
              
                if(dateFuture.getMonth() === dateNow.getMonth()) return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric'});

                return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric', month: 'numeric' });
            }
            return dateFuture.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'numeric', year: 'numeric' });
        },

        formatInputDatePickerStorification() {
            if(this.formData.formDataNetwork.instagram.storification.planifiedDate.date == false) return '';
            let dateNow = new Date()
            let dateFuture = new Date(this.formData.formDataNetwork.instagram.storification.planifiedDate.date)
      
            if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                if (Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24)) < 7) {
                    if (dateFuture.getDay() === dateNow.getDay()) return this.$t('dash.post-creator.render.today')
                    if (dateFuture.getDay() === dateNow.getDay()+1) return this.$t('dash.post-creator.render.tomorrow')
                    return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long' });
                }
              
                if(dateFuture.getMonth() === dateNow.getMonth()) return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric'});

                return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric', month: 'numeric' });
            }
            return dateFuture.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'numeric', year: 'numeric' });
        },

        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },

        stickers() {
            return this.formData.storification[this.idStorySelected].stickers
        },

        backgroundFileId() {
            return this.idStorySelected && this.formData.storification[this.idStorySelected].background.file ? this.formData.storification[this.idStorySelected].background.file.id : null
        },

        // Mirrors Form.vue's own isMediaLoading(id) - a single flat computed here (not a method)
        // since a story only ever has one background slot at a time, unlike Form.vue's media list.
        isBackgroundMediaLoading() {
            const file = this.files[this.backgroundFileId]
            if (!file) return false
            return (!file.isUpload && file.uploadProgress) || file.isNormalizing
        },

        hasPostSticker() {
            return this.idStorySelected && Object.values(this.formData.storification[this.idStorySelected].stickers).some(s => s.type === 'post')
        }
       
    },
    watch: {
        ["stickers"]: {
            handler() {
                this.sortStickers()
            },
            deep: true,
            immediate: true
        },
        ["idStorySelected"]: {
            handler() {
                this.sortStickers()
            },
            deep: true,
            immediate: true
        },
       
        ["formData.planifiedDate.date"]: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!newValue || !newValue.length) {
                    this.formData.planifiedDate.hours = false
                    this.formData.planifiedDate.timestamp = false
                }else{
                    this.checkValidHours()
                }
            }
        },

        ["formData.formDataNetwork.instagram.storification.planifiedDate.date"]: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!newValue || !newValue.length) {
                    this.formData.formDataNetwork.instagram.storification.planifiedDate.hours = false
                    this.formData.formDataNetwork.instagram.storification.planifiedDate.timestamp = false
                }else{
                    this.checkValidHoursStorification()
                }
            }
        },

        ["formData.files"](newValue, oldValue) {
            this.$emit('saveFormData')
        },   
    },

}




</script>